import {
  chooseLocationText,
  invalidPostalCodeErrorText,
  manualStateAndCountryText,
} from '../form/paymentValidation';
import ValidationMessages from '../../constants/subscription/validationMessages';
import subscribe from '../../constants/analytics/categoryActionLabel/subscribe';

/**
 * Called in PaymentForm component when standardizing form error message when a submission fails.
 * @param error {Error|SubmissionError}
 * @returns {object}
 */
export default function getSubscriptionError(error, formId) {
  const {
    postalCodeMultiple,
    postalCodeInvalid,
    postalCodeNotFound,
    invalidPaymentInformation,
  } = subscribe.labels;

  const formType =
    formId === subscribe.labels.renew ? formId : subscribe.labels.payment;

  let failedMsg;
  let failedLabel;

  const message = error && error.message;
  if (ValidationMessages.includes(message)) {
    failedMsg = message;
    switch (message) {
      case chooseLocationText:
        failedLabel = postalCodeMultiple;
        break;
      case manualStateAndCountryText:
        failedLabel = postalCodeInvalid;
        break;
      case invalidPostalCodeErrorText:
        failedLabel = postalCodeNotFound;
        break;
      default:
        failedLabel = invalidPaymentInformation;
    }
  }
  failedLabel = failedLabel ? `${formType}.${failedLabel}` : formType;
  return {
    failureMessage: failedMsg,
    failedAction: subscribe.actions.fail,
    failedLabel,
  };
}
